import { takeLatest, call, put } from "redux-saga/effects";
import { CITY_PAGE_LOAD, cityPageLoaded } from "../../actions/cities";
import listRegions from "../../../../../backend/oncall/partners/regions/list";
import getCity from "../../../../../backend/oncall/partners/cities/get-by-id";
import { regionsLoaded } from "../../actions/regions";
import { showErrorPage } from "../../../../../actions/ui/location";

const cityPageLoadSaga = function*(action) {
  try {
    const regionsResult = yield call(listRegions);
    yield put(regionsLoaded(regionsResult.regions));
    if (action.payload.cityId === undefined) {
      // These are the default values on the add page.
      yield put(
        cityPageLoaded({
          name: "",
          state: "-1",
          regionId: "-1",
          enabled: true,
        }),
      );
      return;
    }
    const result = yield call(getCity, action.payload.cityId);
    yield put(cityPageLoaded(result));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(CITY_PAGE_LOAD, cityPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/cities/edit-page-load.js